import type { ComponentPropsWithoutRef } from 'react';

import { Flex } from '@/hen-ui/composites/Flex';

export interface CareerExplorerShellProps
  extends Omit<
    ComponentPropsWithoutRef<typeof Flex>,
    'className' | 'direction'
  > {}

export const CareerExplorerShell = ({
  children,
  ...props
}: CareerExplorerShellProps) => (
  <Flex
    {...props}
    direction='column'
    className='rounded-lg border border-neutral-200 bg-neutral-100 p-lg md:p-md'
  >
    {children}
  </Flex>
);
